import { defer, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { IPC_CHANNEL } from '../../_offline/electron.constants';
import { MeasurementIntermediateInfoSchema } from '../../_offline/models/measurement-intermediate-info.schema';
import { ElectronService } from '../../electron.service';

/**
 * MeasurementIntermediateInfo 用 DB サービス。
 */
@Injectable({
  providedIn: 'root'
})
export class MeasurementIntermediateInfoDbService {

  public constructor(
    private electronService: ElectronService
  ) { }

  /**
   * MeasurementIntermediateInfo を取得する。
   *
   * @param inspectionImageId 検査画像 ID。
   * @returns MeasurementIntermediateInfoSchema。
   */
  public get(inspectionImageId: string): Observable<MeasurementIntermediateInfoSchema> {
    return defer(() => of(this.electronService.sendSyncCommand(IPC_CHANNEL.MEASUREMENTINTERMEDIATEINFO.GET_ONE, ...[inspectionImageId])))
      .pipe(
        map(x => x as MeasurementIntermediateInfoSchema)
      );
  }

  /**
   * MeasurementIntermediateInfo を追加、更新する。
   *
   * @param measurementIntermediateInfo MeasurementIntermediateInfoSchema。
   * @returns MeasurementIntermediateInfoSchema。
   */
  public put(measurementIntermediateInfo: MeasurementIntermediateInfoSchema): Observable<MeasurementIntermediateInfoSchema> {
    return defer(() => of(this.electronService.sendSyncCommand(IPC_CHANNEL.MEASUREMENTINTERMEDIATEINFO.PUT_ONE, ...[measurementIntermediateInfo])))
      .pipe(
        map(x => x as MeasurementIntermediateInfoSchema)
      );
  }

  /**
   * MeasurementIntermediateInfo を削除する。
   *
   * @param inspectionImageId 検査画像 ID。
   * @returns true … 削除済み。
   */
  public delete(inspectionImageId: string): Observable<boolean> {
    return defer(() => of(this.electronService.sendSyncCommand(IPC_CHANNEL.MEASUREMENTINTERMEDIATEINFO.DELETE_ONE, ...[inspectionImageId])))
      .pipe(
        map(x => x as boolean)
      );
  }

  /**
   * MeasurementIntermediateInfoSchema を複数削除する。
   *
   * @param inspectionImageIds 検査画像 ID の配列。
   * @returns true … 削除済み。
   */
  public deleteMultiple(inspectionImageIds: Array<string>): Observable<boolean> {
    return defer(() => of(this.electronService.sendSyncCommand(IPC_CHANNEL.MEASUREMENTINTERMEDIATEINFO.DELETE_MULTIPLE, ...[inspectionImageIds])))
      .pipe(
        map(x => x as boolean)
      );
  }

}
